import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    IconButton
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const CommonDialog = ({
    open,
    onClose,
    title,
    children,
    cancelText = "Cancel",
    confirmText = "Save",
    onConfirm,
    hideButtons = false,
    confirmButtonProps = { variant: "contained", color: "primary" }
}) => {
    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
            {title && (
                <DialogTitle
                    sx={{
                        m: 0,
                        p: 2,
                        backgroundColor: 'primary.main',
                        color: 'white',
                        textAlign: 'center',
                        position: 'relative'
                    }}
                >
                    {title}
                    <IconButton
                        aria-label="close"
                        onClick={onClose}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: 'red',
                            border: "2px dashed red"
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
            )}
            <DialogContent dividers>
                {children}
            </DialogContent>
            {
                hideButtons ? null :
                    <>
                        <DialogActions className='d-flex justify-content-center'>
                            <Button onClick={onClose} color="error" variant='outlined'>{cancelText}</Button>
                            <Button onClick={onConfirm} {...confirmButtonProps}>
                                {confirmText}
                            </Button>
                        </DialogActions>
                    </>
            }
        </Dialog>
    );
};

export default CommonDialog;
